import masthead from "./components/masthead";

(() => {
  masthead.init();
})();